import generateRow from './row.js';
export default function generateRows(data, _ref) {
  var findOrCreateCellStyle = _ref.findOrCreateCellStyle,
    findOrCreateSharedString = _ref.findOrCreateSharedString,
    hasDefaultFont = _ref.hasDefaultFont,
    dateFormat = _ref.dateFormat,
    features = _ref.features;
  return data.map(function (row, index) {
    return generateRow(row, index, {
      findOrCreateCellStyle: findOrCreateCellStyle,
      findOrCreateSharedString: findOrCreateSharedString,
      hasDefaultFont: hasDefaultFont,
      dateFormat: dateFormat,
      features: features
    });
  }).join('');
}
//# sourceMappingURL=rows.js.map